//@ts-nocheck
import React from "react";
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface IDialogProps extends DialogProps {
  content?: any;
  title?: any;
  actions?: any;
}

const Dialog = ({
  title,
  open,
  content,
  actions,
  onClose = () => {},
  ...rest
}: IDialogProps) => {
  return (
    <MuiDialog open={open} onClose={onClose} {...rest}>
      <DialogTitle sx={{ pt: "26px", pb: "34px" }} >
        {title}
        {onClose ? (
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "14px",
              right: "28px",
              color: "action.active",
            }}
            id="btn-dialogmarketplace-close"
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent id="lbl-dialogmarketplace-content" sx={{ pb: content ? "30px" : 0 }}>{content}</DialogContent>
      <DialogActions id="btn-dialogmarketplace-actions" sx={{ pb: "22px", pr: "24px" }}>{actions}</DialogActions>
    </MuiDialog>
  );
};
export default Dialog;
